.a2{overflow:hidden;}